export const SET_SIGN_IN = "SET_SIGN_IN";
export const SET_SHOW_SIGNIN = "SET_SHOW_SIGNIN";
export const SET_SHOW_SIGNUP = "SET_SHOW_SIGNUP";
export const SET_LOADING = "SET_LOADING";

export const SET_AUTH = "SET_AUTH";

export const SET_USER = "SET_USER";

export const SET_PATH = "SET_PATH";

export const SET_REMEMBER_ME = "SET_REMEMBER_ME";

export const SET_BRIEFS = "SET_BRIEFS";

export const SET_DETAIL = "SET_DETAIL";
export const SET_LISTSTYLE = "SET_LISTSTYLE";
export const SET_LISTWHAT = "SET_LISTWHAT";

export const SET_GLOBAL_CONDITIONS = "SET_GLOBAL_CONDITIONS";
export const SET_SNACK_INFO = "SET_SNACK_INFO";
